export default __webpack_public_path__ + "static/media/Emojis04.591d4ee7.png";